module.exports = __webpack_public_path__ + "static/media/ordinary-people.6527eb7f.mp3";